import React from 'react';
import { Check } from 'lucide-react';
import { instituteMock } from '../data/mock';

const Structure = () => {
  const { structure } = instituteMock;

  return (
    <section className="section-padding bg-secondary" id="structure-section">
      <div className="container">
        <div className="grid-two-column">
          <div className="structure-image">
            <img 
              src={structure.image} 
              alt="Estrutura e tecnologia" 
              loading="lazy"
            />
          </div>
          <div className="structure-content">
            <h2 className="heading-1" style={{ marginBottom: '16px' }}>
              {structure.title}
            </h2>
            <p className="body-large" style={{ marginBottom: '32px' }}>
              {structure.description}
            </p>
            <ul className="structure-list">
              {structure.features.map((feature, index) => (
                <li key={index} className="structure-item">
                  <Check size={20} className="check-icon" />
                  <span className="body-regular">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Structure;
